export function makeNetTerms(netTerms) {
    return netTerms === 0 ? {
        type: 'immediate',
        days: null
    } : {
        type: 'net',
        days: netTerms
    };
}
export function netTermsFromDTO(dto) {
    var _dto_days;
    return dto.type === 'immediate' ? {
        type: 'immediate',
        days: null
    } : {
        type: 'net',
        days: (_dto_days = dto.days) !== null && _dto_days !== void 0 ? _dto_days : 0
    };
}
